import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core'
import { CasinoGameItem } from '@/features/casino/casino.model'
import { GameBadgeComponent } from '@/features/casino/components/game-badge/game-badge.component'
import { SiteConfigService } from '@/services/site-config.service'

/**
 * A game as artwork with its name under it: the desktop search results grid
 * ('card', on the light results box) and the Suggested Games row ('plain', on
 * the dark panel). The label and playing count sit over the artwork, as on a
 * lobby card.
 */
@Component({
	selector: 'search-game-tile',
	templateUrl: './search-game-tile.component.html',
	styleUrl: './search-game-tile.component.css',
	imports: [GameBadgeComponent],
	changeDetection: ChangeDetectionStrategy.OnPush,
	host: {
		'[class.plain]': 'appearance() === \'plain\''
	}
})
export class SearchGameTileComponent {
	readonly game = input.required<CasinoGameItem>()
	readonly appearance = input<'card' | 'plain'>('card')

	private readonly siteConfigService = inject(SiteConfigService)

	protected readonly playing = computed(() =>
		new Intl.NumberFormat(this.siteConfigService.activeLocale()).format(this.game().inPlay)
	)
}
